import { useMemo, useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem,
  Grid, Typography, Box, Divider,
} from '@mui/material'
import { formatCurrency } from '../../utils/format'

// Registro del cobro de la factura recién creada (port de detallecobroagil-modal.html).
export default function CobroModal({ open, total, moneda, formasPago = [], onConfirm, onClose, loading }) {
  const [formaPago, setFormaPago] = useState(null)
  const [importe, setImporte] = useState(total || 0)

  const saldo = useMemo(() => Math.max(0, (Number(total) || 0) - (Number(importe) || 0)), [total, importe])
  const vuelto = useMemo(() => Math.max(0, (Number(importe) || 0) - (Number(total) || 0)), [total, importe])
  const puedeGuardar = Number(importe) > 0 && !!formaPago && saldo === 0

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Cobro de la factura</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField select fullWidth size="small" label="Forma de pago *"
              value={formaPago?.id ?? ''}
              onChange={(e) => setFormaPago(formasPago.find((f) => f.id === e.target.value) || null)}>
              {formasPago.map((f) => <MenuItem key={f.id} value={f.id}>{f.descripcion}</MenuItem>)}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth size="small" type="number" label="Importe"
              value={importe} onChange={(e) => setImporte(e.target.value)} />
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Typography>Total a pagar: <strong>{formatCurrency(total, moneda)}</strong></Typography>
          <Typography color={saldo > 0 ? 'error' : 'success.main'}>Saldo: <strong>{formatCurrency(saldo, moneda)}</strong></Typography>
          <Typography>Vuelto: <strong>{formatCurrency(vuelto, moneda)}</strong></Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" color="secondary" disabled={!puedeGuardar || loading}
          onClick={() => onConfirm({ formaPago, importe: Number(importe) })}>
          Confirmar cobro
        </Button>
      </DialogActions>
    </Dialog>
  )
}
